import { executeHttpCall } from '@/services/httpClientHelper.js'

// Vue.use(Vuex)

const testProductDiagnostics = {
  namespaced: true,
  state: {
    loading: false,
    error: false,
    variables: {
      headings: [],
      options: []
    },
    reportTypes: {
      heading: '',
      options: []
    },
    dataOptions: {
      heading: '',
      options: []
    },
    reportTypesData: {},
    jsonInBackend: {
      data: null
    },
    selected: {
      customReportLink: null,
      reportType: null,
      variables: [],
      periodTypes: [],
      dataOptions: [],
      dateAndTime: {
        raw: {
          dateFrom: '',
          dateTo: '',
          timeFrom: {
            HH: '00',
            mm: '00',
            ss: '00'
          },
          timeTo: {
            HH: '00',
            mm: '00',
            ss: '00'
          }
        },
        formatted: {
          dateFrom: '',
          dateTo: '',
          timeFrom: {
            HH: '00',
            mm: '00',
            ss: '00'
          },
          timeTo: {
            HH: '00',
            mm: '00',
            ss: '00'
          }
        }
      }
    }
  },
  mutations: {
    setState (state, payload) {
      state[payload.prop] = payload.value
    },
    selected (state, payload) {
      state.selected[payload.prop] = payload.value
    },
    jsonInBackend (state, payload) {
      state.jsonInBackend[payload.prop] = payload.value
    },
    overwriteSelected (state, newVal) {
      state.selected = newVal
    },
    setDefaultState (state) {
      state.loading = false
      state.error = false
      state.variables = {
        headings: [],
        options: []
      }
      state.reportTypes = {
        heading: '',
        options: []
      }
      state.reportTypesData = {}
      state.dataOptions = {
        heading: '',
        options: []
      }
      state.selected = {
        variables: [],
        reportType: null,
        periodTypes: []
      }
    },
    setDefaultSelectionState (state) {
      state.selected = {
        customReportLink: null,
        variables: [],
        reportType: null,
        periodTypes: [],
        dateAndTime: {
          raw: {
            dateFrom: '',
            dateTo: '',
            timeFrom: {
              HH: '00',
              mm: '00',
              ss: '00'
            },
            timeTo: {
              HH: '00',
              mm: '00',
              ss: '00'
            }
          },
          formatted: {
            dateFrom: '',
            dateTo: '',
            timeFrom: {
              HH: '00',
              mm: '00',
              ss: '00'
            },
            timeTo: {
              HH: '00',
              mm: '00',
              ss: '00'
            }
          }
        }
      }
    }
  },
  getters: {
    getAllSelections: state => {
      return state.selected
    }
  },
  actions: {
    loadStateFromFile ({ commit, dispatch }, data) {
      dispatch('reset')
      commit('overwriteSelected', data)
    },
    loadData ({ commit }) {
      commit('setState', { prop: 'loading', value: true })
      commit('setState', { prop: 'error', value: false })

      const params = {
        resultFile: 'GetPVGEl',
        _program: 'GetPeriodisedVariablesGUIElements'
      }
      executeHttpCall(params, null).then(response => {
      // getPeriodisedVariablesGuiElements().then(response => {
        // if (isApiTimeoutResponse(response) && !isApiArrayResponse(response)) {
        //   console.error('PeriodisedVariables:getPeriodisedVariablesGuiElements:', 'Session timeout')
        //   commit('setState', { prop: 'error', value: true })
        //   return
        // }
        commit('setState', {
          prop: 'variables',
          value: response.variables
        })
        commit('setState', {
          prop: 'reportTypes',
          value: response.reportTypes
        })
        commit('setState', {
          prop: 'reportTypesData',
          value: response.reportTypesData
        })
        commit('setState', {
          prop: 'dataOptions',
          value: response.dataOptions
        })
      }).catch(error => {
        console.error('TestProduct:getPeriodisedVariablesGuiElements: ', error)
        commit('setState', { prop: 'error', value: true })
      }).finally(() => {
        commit('setState', { prop: 'loading', value: false })
      })
    },
    updateSelection ({ commit }, payload) {
      commit('selected', payload)
    },
    reset ({ commit }) {
      commit('setDefaultState')
      commit('setDefaultSelectionState')
    }
  }
}
export default testProductDiagnostics
